import { Label } from "@/components/ui/label";
import { COLLECTION_LABELS } from "@/lib/sp";

const LEVELS = [["", "Aucun"], ["read", "Lecture"], ["write", "Lecture + écriture"]];

export const ScopePicker = ({ modules = [], value = {}, onChange }) => {
  const setLevel = (name, lvl) => {
    const next = { ...value };
    if (lvl) next[name] = lvl; else delete next[name];
    onChange(next);
  };
  const all = (lvl) => onChange(lvl ? Object.fromEntries(modules.map((m) => [m.name, value[m.name] || "read"])) : {});
  return (
    <div className="space-y-2" data-testid="scope-picker">
      <div className="flex items-center gap-3">
        <Label>Modules accessibles *</Label>
        <button type="button" className="ml-auto text-xs text-[#C2410C] hover:underline" onClick={() => all("read")} data-testid="scope-all-read">Tout en lecture</button>
        <button type="button" className="text-xs text-stone-500 hover:underline" onClick={() => all("")} data-testid="scope-clear">Tout retirer</button>
      </div>
      <div className="rounded-md border border-stone-200 divide-y divide-stone-100 max-h-64 overflow-y-auto">
        {modules.map((m) => (
          <div key={m.name} className="flex flex-wrap items-center gap-2 px-3 py-2 text-sm">
            <span className="text-stone-800 mr-auto">{COLLECTION_LABELS[m.name] || m.name}<span className="ml-2 text-xs text-stone-400">{m.name}</span></span>
            <div className="flex rounded-md border border-stone-200 overflow-hidden">
              {LEVELS.filter(([l]) => l !== "write" || m.writable).map(([l, lab]) => (
                <button type="button" key={l || "none"} onClick={() => setLevel(m.name, l)} data-testid={`scope-${m.name}-${l || "none"}`}
                  className={`px-2.5 py-1 text-xs transition-colors duration-150 ${(value[m.name] || "") === l ? "bg-[#C2410C] text-white" : "bg-white text-stone-600 hover:bg-stone-100"}`}>{lab}</button>
              ))}
            </div>
          </div>
        ))}
      </div>
      <p className="text-xs text-stone-500">L'écriture n'est proposée que pour les modules modifiables depuis la plateforme ; chaque modification est envoyée à Sehatic-Pedia.</p>
    </div>
  );
};
